import * as SubscriptionManager from "../state 2 interface/SubscriptionManager";
import { onFinishedApplyingDefaults, applyingDefaults } from "./defaults";
import { referencesResolved, resolvingReferences } from "../state 2 interface/referenceResolver";
import * as microtaskQueue from "../microtaskQueue";
import * as queryQueue from "../queryQueue";

export default async function clientWorkIsDone() {
	do {
		await onFinishedApplyingDefaults();
		await referencesResolved();
		await SubscriptionManager.finishedAndInitialized();
		await microtaskQueue.done();
		await queryQueue.done();
	} while (
		applyingDefaults.size.value > 0 ||
		resolvingReferences.size.value > 0 ||
		SubscriptionManager.size() > 0 ||
		microtaskQueue.size() > 0 ||
		queryQueue.size() > 0
	);
}
